module.exports = __webpack_public_path__ + "img/fi.f92afcfd.svg";